import React, { Component } from 'react';
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon, } from "@fortawesome/react-fontawesome";
import '../css/qtyEdit.css';
export class QtyEdit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            usedBin: this.props.usedBin,
            binInfo: this.props.binInfo,
            item: this.props.item,
            qtyDisplay: this.props.useBins ? this.props.usedBin.qty : this.props.item.quantityPicked
        }
        this.validateQuantityChange = this.validateQuantityChange.bind(this);
        this.validateTypeInput = this.validateTypeInput.bind(this);
    }

    componentDidMount() {
        document.getElementById('qty-edit-input').focus();
    }

    validateQuantityChange(value, maxQty) {
        if (this.props.useBins) {
            var binInfo = this.state.binInfo;
            var binId = binInfo.binId;
            var usedBin = this.state.usedBin;
            var originalQty = usedBin.qty;
            var newQty = originalQty + value;
            var lineId = this.props.item.lineId;
            if (value > binInfo.onHand && binInfo.bin != 'Non-Inventory') {
                alert("You cannot add any more, the bin only has " + (originalQty + binInfo.onHand) + " items.");
                document.getElementById('qty-edit-input').focus();
                return;
            }
            else if (newQty < 0 || newQty > maxQty) {
                if (newQty > maxQty) {
                    alert("You do not need any more of this item.")
                    document.getElementById('qty-edit-input').focus();
                }
                return;
            }
            usedBin.qty = newQty;
            binInfo.onHand -= value;
            this.setState({
                usedBin: usedBin,
                binInfo: binInfo,
                qtyDisplay: newQty
            })
            this.props.updateQuantityWBins(lineId, usedBin, binId, binInfo, value);
        }
        else {
            var item = this.state.item;
            var newQty = item.quantityPicked + value;
            if (newQty < 0 || newQty > maxQty) {
                if (newQty > maxQty) {
                    alert("You do not need any more of this item. You only need " + maxQty);
                    document.getElementById('qty-edit-input').focus();
                }
                return;
            }
            item.quantity = item.quantity - value;
            item.quantityPicked = newQty;
            this.setState({
                item: item,
                qtyDisplay: newQty
            });
            this.props.updateQuantity(item)
        }
        document.getElementById('qty-edit-input').focus();
    }

    validateTypeInput(e, maxQty) {
        var newQty = e.target.value;
        if (!newQty) {
            this.setState({
                qtyDisplay: ''
            });
            document.getElementById('qty-edit-input').focus();
            return;
        }
        else {
            newQty = parseInt(newQty);
        }
        if (newQty > maxQty) {
            alert("You must enter a number between 0 and " + maxQty);
            document.getElementById('qty-edit-input').focus();
            return;
        }
        if (this.props.useBins) {
            var usedBin = this.state.usedBin;
            var qtyDifference = newQty - usedBin.qty;
        }
        else {
            var item = this.state.item;
            var qtyDifference = newQty - item.quantityPicked;
        }
        this.validateQuantityChange(qtyDifference, maxQty);
    }


    render() {
        var binId = this.state.binInfo.binId;
        var usedBin = this.state.usedBin;
        var maxQty = this.props.useBins ? parseInt(usedBin.qty + this.props.item.quantity) : parseInt(this.props.item.quantity + this.props.item.quantityPicked);
        var binInfo = this.props.binInfo;
        return (
            <div className="bin-qty-edit">
                {this.props.useBins ? <h2>Bin: {binInfo.bin}</h2> : <h2>{this.props.item.itemName}</h2> }
                <div class="number">
                    <FontAwesomeIcon className="imageIcon" onClick={() => this.validateQuantityChange(-1, maxQty)} size="lg" icon={faMinus} />
                    <input id="qty-edit-input" onChange={(e) => { this.validateTypeInput(e, maxQty) }} type="number" value={this.state.qtyDisplay} min="0" max={maxQty} />
                    <FontAwesomeIcon className="imageIcon" onClick={() => this.validateQuantityChange(1, maxQty)} size="lg" icon={faPlus} />
                </div>
            </div>
        );
    }
}
